import React, { useState } from "react";
import "./Banking.css";

const FILTERS = ["All", "Card", "Investing", "Family"];

const HUB_FEATURES = [

  {
    id: "multi-currency",
    category: "Card",
    badge: "LIVE",
    badgeType: "live",
    emoji: "🌍",
    title: "Multi-Currency Account",
    highlight: "0% fees",
    subtitle: "Hold EUR, GBP, USD — no conversion on spending",
    photo: "https://images.unsplash.com/photo-1580519542036-c47de6196ba5?auto=format&fit=crop&w=430&h=200&q=80",
  },
  {
    id: "ncw-crypto",
    category: "Card",
    badge: "NEW",
    badgeType: "new",
    emoji: "🔐",
    title: "NCW Crypto Debit Card",
    highlight: "Your keys",
    subtitle: "Spend directly from your non-custodial wallet",
    photo: "https://images.unsplash.com/photo-1621504450181-5d356f61d307?auto=format&fit=crop&w=430&h=200&q=80",
  },
  {
    id: "smart-sweep",
    category: "Investing",
    badge: "SOON",
    badgeType: "soon",
    emoji: "🔄",
    title: "Smart Sweep",
    highlight: "Auto",
    subtitle: "Idle cash above your threshold flows into investments",
    photo: "https://images.unsplash.com/photo-1554224155-8d04cb21cd6c?auto=format&fit=crop&w=430&h=200&q=80",
  },
  {
    id: "round-up",
    category: "Investing",
    badge: "SOON",
    badgeType: "soon",
    emoji: "📈",
    title: "Round-Up Investing",
    highlight: "Every purchase",
    subtitle: "Round up transactions and invest your spare change",
    photo: "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?auto=format&fit=crop&w=430&h=200&q=80",
  },
  {
    id: "stock-gifting",
    category: "Investing",
    badge: "SOON",
    badgeType: "soon",
    emoji: "🎁",
    title: "Stock Gifting",
    highlight: "Send stocks",
    subtitle: "Give fractional shares to anyone — the best gift card",
    photo: "https://images.unsplash.com/photo-1512909006721-3d6018887383?auto=format&fit=crop&w=430&h=200&q=80",
  },
  {
    id: "ai-allocation",
    category: "Investing",
    badge: "SOON",
    badgeType: "soon",
    emoji: "🤖",
    title: "AI Auto-Allocation",
    highlight: "AI-powered",
    subtitle: "Portfolio optimised to your goals and risk profile",
    photo: "https://images.unsplash.com/photo-1677442135703-1787eea5ce01?auto=format&fit=crop&w=430&h=200&q=80",
  },
  {
    id: "family-cards",
    category: "Family",
    badge: "SOON",
    badgeType: "soon",
    emoji: "👨‍👩‍👧‍👦",
    title: "Family Cards",
    highlight: "Up to 5",
    subtitle: "Issue cards to family members with spending controls",
    photo: "https://images.unsplash.com/photo-1609220136736-443140cffec6?auto=format&fit=crop&w=430&h=200&q=80",
  },
];

function HubCard({ f }) {
  return (
    <div className="hub-card">
      <div className="hub-card-photo-wrap">
        <img
          src={f.photo}
          alt={f.title}
          className="hub-card-photo"
          onError={e => { e.target.style.display = "none"; }}
        />
        <div className="hub-card-photo-overlay" />
      </div>
      <div className="hub-card-content">
        <div className="hub-card-top">
          <span className="hub-card-emoji">{f.emoji}</span>
          <span className={`hub-badge hub-badge--${f.badgeType}`}>{f.badge}</span>
        </div>
        <div className="hub-card-body">
          <span className="hub-card-title">{f.title}</span>
          <span className="hub-card-highlight">{f.highlight}</span>
          <span className="hub-card-subtitle">{f.subtitle}</span>
        </div>
      </div>
    </div>
  );
}

export default function Banking() {
  const [activeFilter, setActiveFilter] = useState("All");

  const filtered =
    activeFilter === "All"
      ? HUB_FEATURES
      : HUB_FEATURES.filter(f => f.category === activeFilter);

  return (
    <div className="hub-page">
      {/* Hero */}
      <section className="hub-hero">
        <div className="hub-hero-top">
          <div>
            <h1 className="hub-title">Hub</h1>
            <p className="hub-tier">
              <span className="hub-tier-dot" />
              Diamond member
            </p>
          </div>

        </div>
        <p className="hub-subtitle">Your complete financial superpowers in one place</p>
      </section>

      {/* Filters */}
      <div className="hub-filters">
        {FILTERS.map(f => (
          <button
            key={f}
            type="button"
            className={`filter-tab ${activeFilter === f ? "active" : ""}`}
            onClick={() => setActiveFilter(f)}
          >
            {f}
          </button>
        ))}
      </div>

      {/* Cards */}
      <div className="hub-list">
        {filtered.map(f => (
          <HubCard key={f.id} f={f} />
        ))}
      </div>

      <footer className="hub-footer">Powered by Visa</footer>
      <div style={{ height: 80 }} />
    </div>
  );
}
